import globalAxios from "axios";
import fetchAdapter from "./adapters/fetch";
let axiosWithOptionalFetch;
// detect CF worker environment
if (typeof process === "undefined") {
    axiosWithOptionalFetch = globalAxios.create({
        // @ts-ignore
        adapter: fetchAdapter,
    });
}
else {
    axiosWithOptionalFetch = globalAxios;
}
export default axiosWithOptionalFetch;
